interface SortByNameProps<T = any> {
  list: T[];
  shortKey: string;
  orderMap: { [key: string]: number };
}

const sortByName = ({ list, orderMap, shortKey }: SortByNameProps) => {
  if (Array.isArray(list) && list.length > 0) {
    const newList = [...list].sort((a, b) => {
      const aName: string = a?.[shortKey]?.toLowerCase();
      const bName: string = b?.[shortKey]?.toLowerCase();

      const orderA = orderMap[aName] ?? Number.MAX_SAFE_INTEGER;
      const orderB = orderMap[bName] ?? Number.MAX_SAFE_INTEGER;

      return orderA - orderB;
    });

    return newList;
  }

  return [];
};

export default sortByName;
